import { useState, useRef, useEffect } from 'react';
import { useApp } from '../../context/AppContext';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase';
// import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
// import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { predefinedIcons } from '../../constants/menuIcons';

import { Payment } from '@mercadopago/sdk-react';

function Step6() {
  const { state, dispatch } = useApp();
  const { appData, totalPrice, priceBreakdown } = state;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [iframeKey, setIframeKey] = useState(0);
  const [iframeError, setIframeError] = useState(false);
  const [saving, setSaving] = useState(false);
  // const [uploadProgress, setUploadProgress] = useState({ logo: 0, splash: 0 });
  const iframeRef = useRef(null);
  const [objectUrls, setObjectUrls] = useState({ logo: null, splash: null });
  // const [paymentInitiated] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [appId] = useState(null);
  const [showPixModal, setShowPixModal] = useState(false);
  const [pixData, setPixData] = useState(null);
  const [ticketUrl, setTicketUrl] = useState(null);

  // Novos estados para tratamento avançado do iframe
  const [errorDetails, setErrorDetails] = useState('');
  const [useHttps, setUseHttps] = useState(true);
  const [retryCount, setRetryCount] = useState(0);

  // Função para formatar a URL corretamente com tratamento de protocolo
  const getSiteUrl = () => {
    if (!appData.url) return 'https://exemplo.com';
    
    let url = appData.url;
    // Remove protocolos existentes
    url = url.replace(/^https?:\/\//, '');
    
    // Força HTTPS por padrão, mas permite fallback para HTTP
    if (useHttps) {
      return `https://${url}`;
    } else {
      return `http://${url}`;
    }
  };

  const siteUrl = getSiteUrl();

  // Função para finalizar e resetar todos os dados
  const handleFinalize = async () => {
    try {
      // 1️⃣ Primeiro redirecionar
      navigate('/dashboard', {
        state: {
          message: 'Seu aplicativo está sendo processado. O status é: Ops! Você tem um pagamento em aberto 😉',
          appId: appId,
          status: 'Ops! Você tem um pagamento em aberto 😉'
        },
        replace: true
      });

      // 2️⃣ Depois resetar o contexto (com pequeno delay para garantir o redirecionamento)
      setTimeout(() => {
        dispatch({ type: 'RESET_APP_DATA' });

        // 3️⃣ Limpar localStorage
        localStorage.removeItem('step1');
        localStorage.removeItem('step2');
        localStorage.removeItem('step3');
        localStorage.removeItem('step4');
      }, 100);

    } catch (error) {
      console.error('Erro ao finalizar compra:', error);
    }
  };

  // Inicialização do Mercado Pago com a chave pública de PRODUÇÃO
  useEffect(() => {
    const PUBLIC_KEY = process.env.REACT_APP_MP_PUBLIC_KEY || 'APP_USR-17381018-de8e-44a4-bfb7-e1303b6f6d19';
    import('@mercadopago/sdk-react').then(({ initMercadoPago }) => {
      initMercadoPago(PUBLIC_KEY, { locale: 'pt-BR' });
    }).catch(err => console.log('Erro ao carregar MP SDK', err));
  }, []);

  const [showPaymentModal, setShowPaymentModal] = useState(false);

  // A função handlePayment agora apenas abre o modal de checkout nativo
  const handlePayment = async () => {
    setShowPaymentModal(true);
  };

  const handleCheckoutSubmit = async (paymentBrickResponse) => {
    setSaving(true);
    setShowPaymentModal(false);
    // setUploadProgress({ logo: 0, splash: 0 });

    try {
      const user = auth.currentUser;
      if (!user) throw new Error('Usuário não autenticado');

      // (Aqui iria a lógica de Upload de Imagens omitida por brevidade na tela visual)
      let logoUrl = appData.logo instanceof File ? '' : appData.logo;
      let splashUrl = appData.splash instanceof File ? '' : appData.splash;

      const appConfig = {
        name: appData.name,
        url: appData.url,
        logo: logoUrl,
        splash: splashUrl,
        loaderColor: appData.loaderColor,
        platforms: appData.platforms,
        hasMenu: appData.hasMenu,
        menuColor: appData.menuColor,
      };

      // O Payment Brick do SDK retorna um objeto contendo formData
      const actualPaymentData = paymentBrickResponse.formData || paymentBrickResponse;
      console.log('Dados do cartão enviados pelo Brick:', actualPaymentData);
      
      // Chamada real para a API Node.js local/VPS
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
      const response = await fetch(`${apiUrl}/processCheckout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          appConfig,
          paymentData: actualPaymentData,
          userAuth: {
            uid: user.uid,
            email: user.email
          }
        })
      });
      
      const data = await response.json();
      console.log('Resposta do backend:', data);
      
      if (data.success) {
        setSaving(false);
        if (data.paymentMethodId === 'pix' && data.pix) {
          setPixData(data.pix);
          setShowPixModal(true);
        } else {
          if (data.ticketUrl) {
            setTicketUrl(data.ticketUrl);
          }
          setShowSuccessModal(true);
        }
      } else {
        throw new Error('Falha ao processar pagamento.');
      }
      
    } catch (error) {
      console.error('Erro no checkout:', error);
      alert(`Erro: ${error.message}`);
      setSaving(false);
    }
  };

  const handleGoToDashboard = () => {
    handleFinalize();
  };

  const handleBack = () => {
    dispatch({ type: 'PREV_STEP' });
  };

  // Função para recarregar o iframe
  const reloadIframe = () => {
    setIframeKey(prev => prev + 1);
    setIsLoading(true);
    setIframeError(false);
    setErrorDetails('');
    setRetryCount(prev => prev + 1);
  };

  // Função para alternar entre HTTPS e HTTP
  const toggleProtocol = () => {
    setUseHttps(!useHttps);
    setRetryCount(0);
    reloadIframe();
  };

  // Função para tentar automaticamente com HTTP se HTTPS falhar
  const handleIframeError = () => {
    setIsLoading(false);
    setIframeError(true);
    setErrorDetails('Conexão recusada pelo site. Tentando solução alternativa...');
    
    // Tentar automaticamente sem HTTPS após 2 segundos se ainda não tentou
    if (useHttps && retryCount < 2) {
      setTimeout(() => {
        setUseHttps(false);
        reloadIframe();
      }, 2000);
    }
  };

  // Criar object URLs apenas uma vez e limpar corretamente
  useEffect(() => {
    const newObjectUrls = {};

    if (appData.logo instanceof File) {
      newObjectUrls.logo = URL.createObjectURL(appData.logo);
    }

    if (appData.splash instanceof File) {
      newObjectUrls.splash = URL.createObjectURL(appData.splash);
    }

    setObjectUrls(newObjectUrls);

    return () => {
      if (newObjectUrls.logo) URL.revokeObjectURL(newObjectUrls.logo);
      if (newObjectUrls.splash) URL.revokeObjectURL(newObjectUrls.splash);
    };
  }, [appData.logo, appData.splash]);

  // Debug avançado para iframe
  useEffect(() => {
    console.log('🔍 Iframe Debug Info:', {
      siteUrl,
      useHttps,
      iframeKey,
      isLoading,
      iframeError,
      errorDetails,
      retryCount
    });
  }, [siteUrl, iframeKey, isLoading, iframeError, errorDetails, retryCount, useHttps]);

  // Componente com ícones PNG
  const CardIcons = () => (
    <div className="flex justify-center space-x-4 mt-4">
      <img
        src="https://logodownload.org/wp-content/uploads/2014/07/mastercard-logo-8.png"
        width="40"
        height="24"
        alt="Mastercard"
        className="object-contain"
      />
      <img
        src="https://www.pikpng.com/pngl/b/80-809937_visa-png-transparent-background-visa-logo-clipart.png"
        width="40"
        height="24"
        alt="Visa"
        className="object-contain"
      />
    </div>
  );

  return (
    <div className="flex flex-col xl:flex-row gap-6 lg:gap-8 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full">
      {/* Modal de progresso de upload */}
      {saving && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
          <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full mx-auto">
            <h3 className="text-xl font-bold mb-6 text-center text-gray-900">
              Processando Pagamento...
            </h3>

            <div className="flex justify-center mt-6">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-gray-900"></div>
            </div>
          </div>
        </div>
      )}

      {/* Modal de sucesso (Cartão de Crédito etc) */}
      {showSuccessModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm">
          <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full mx-auto">
            <div className="text-center">
              <div className="text-green-500 text-6xl mb-6">✓</div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                {ticketUrl ? 'Boleto Gerado!' : 'Pagamento Aprovado!'}
              </h3>
              <p className="text-gray-600 mb-6 text-lg">
                {ticketUrl 
                  ? 'Seu aplicativo foi salvo. Pague o boleto para iniciarmos a publicação.' 
                  : 'Seu aplicativo foi salvo e o pagamento processado com sucesso.'}
              </p>

              {ticketUrl && (
                <a
                  href={ticketUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full block mb-4 px-8 py-4 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition-all font-bold"
                >
                  Imprimir/Visualizar Boleto
                </a>
              )}

              <button
                onClick={handleGoToDashboard}
                className="w-full px-8 py-4 bg-gray-900 text-white rounded-xl hover:bg-black transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 font-bold"
              >
                Ir para Dashboard
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de PIX */}
      {showPixModal && pixData && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm overflow-y-auto">
          <div className="bg-white p-8 rounded-2xl shadow-2xl max-w-md w-full mx-auto relative text-center">
            <button 
              onClick={() => setShowPixModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 focus:outline-none transition-colors"
              aria-label="Fechar"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">Pagamento via PIX</h3>
            <p className="text-gray-600 mb-6">Escaneie o QR Code abaixo ou copie o código PIX Copia e Cola para pagar.</p>
            
            {pixData.qrCodeBase64 && (
              <img src={`data:image/jpeg;base64,${pixData.qrCodeBase64}`} alt="QR Code PIX" className="mx-auto w-48 h-48 mb-4 border border-gray-200 rounded-lg p-2" />
            )}
            
            <div className="mb-6 text-left">
              <label className="block text-sm font-medium text-gray-700 mb-1">PIX Copia e Cola:</label>
              <div className="flex">
                <input 
                  type="text" 
                  readOnly 
                  value={pixData.qrCode || ''} 
                  className="block w-full rounded-l-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm p-2 border bg-gray-50 text-gray-500"
                />
                <button 
                  onClick={() => {
                    navigator.clipboard.writeText(pixData.qrCode);
                    alert('Código PIX copiado!');
                  }}
                  className="inline-flex items-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 px-3 text-sm font-medium text-gray-700 hover:bg-gray-100"
                >
                  Copiar
                </button>
              </div>
            </div>

            <button
              onClick={handleGoToDashboard}
              className="w-full px-8 py-3 bg-gray-900 text-white rounded-xl hover:bg-black transition-all font-bold"
            >
              Já paguei (Ir para o Painel)
            </button>
          </div>
        </div>
      )}

      {/* Modal de Pagamento (Mercado Pago Brick) */}
      {showPaymentModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 backdrop-blur-sm overflow-y-auto">
          <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-2xl max-w-2xl w-full mx-auto my-8 relative">
            <button 
              onClick={() => setShowPaymentModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-900 transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
            <h3 className="text-2xl font-bold mb-2 text-gray-900">Finalizar Compra</h3>
            <p className="text-gray-600 mb-6">Total a pagar: <strong className="text-gray-900">R$ {totalPrice.toFixed(2)}</strong></p>
            
            <div className="min-h-[400px]">
              <Payment
                initialization={{ amount: totalPrice }} // Apenas amount para transparente
                customization={{
                  paymentMethods: {
                    creditCard: 'all',
                    debitCard: 'all',
                    ticket: 'all',
                    bankTransfer: 'all',
                  },
                }}
                onSubmit={handleCheckoutSubmit}
                onError={(error) => console.error(error)}
                onReady={() => console.log('Payment Brick Ready!')}
              />
            </div>
          </div>
        </div>
      )}

      {/* Resumo e informações - Lado esquerdo */}
      <div className="flex-1 w-full">
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">Resumo do Aplicativo</h2>
          <p className="text-gray-600 text-lg">Revise todas as informações antes de finalizar</p>
        </div>

        <div className="space-y-8">
          {/* Informações Básicas */}
          <div className="bg-white p-8 rounded-2xl shadow-xl">
            <h3 className="text-xl font-bold mb-6 text-gray-900 border-b border-gray-100 pb-4">Informações Básicas</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">Nome do App</p>
                <p className="font-semibold text-lg text-gray-900 mt-1">{appData.name || 'Não definido'}</p>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">URL do Site</p>
                <p
                  title={siteUrl}
                  className="font-semibold text-lg text-gray-900 mt-1 break-all"
                >
                  {siteUrl}
                </p>
              </div>

              <div>
                <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">Categoria</p>
                <p className="font-semibold text-lg text-gray-900 mt-1">{appData.category || 'Geral'}</p>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">Status Inicial</p>
                <p className="font-semibold text-lg text-orange-600 mt-1">Pendente</p>
              </div>
            </div>
          </div>

          {/* Design */}
          <div className="bg-white p-8 rounded-2xl shadow-xl">
            <h3 className="text-xl font-bold mb-6 text-gray-900 border-b border-gray-100 pb-4">Design</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div>
                <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">Logo</p>
                {appData.logo ? (
                  <img
                    src={objectUrls.logo || appData.logo}
                    alt="Logo"
                    className="h-16 w-16 object-contain mt-2 rounded-lg border border-gray-100 shadow-sm"
                  />
                ) : (
                  <p className="font-medium text-gray-400 text-lg mt-1">Não definido</p>
                )}
              </div>
              <div>
                <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">Splash Screen</p>
                {appData.splash ? (
                  <img
                    src={objectUrls.splash || appData.splash}
                    alt="Splash"
                    className="h-16 w-16 object-contain mt-2 rounded-lg border border-gray-100 shadow-sm"
                  />
                ) : (
                  <p className="font-medium text-gray-400 text-lg mt-1">Não definido</p>
                )}
              </div>
              <div>
                <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">Cor do Loader</p>
                <div className="flex items-center mt-2">
                  <div
                    className="w-8 h-8 rounded-full border border-gray-200 mr-3 flex-shrink-0 shadow-sm"
                    style={{ backgroundColor: appData.loaderColor }}
                  ></div>
                  <span className="font-semibold text-lg text-gray-900 break-all">{appData.loaderColor}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Plataformas */}
          <div className="bg-white p-8 rounded-2xl shadow-xl">
            <h3 className="text-xl font-bold mb-6 text-gray-900 border-b border-gray-100 pb-4">Plataformas</h3>
            <div className="flex flex-wrap gap-3">
              {appData.platforms && appData.platforms.length > 0 ? (
                appData.platforms.map(platform => (
                  <span 
                    key={platform} 
                    className="bg-gray-900 text-white px-4 py-2 rounded-xl text-sm font-bold shadow-md"
                  >
                    {platform === 'android' ? 'Android' : 'iOS'}
                  </span>
                ))
              ) : (
                <p className="text-gray-400 text-lg">Nenhuma plataforma selecionada</p>
              )}
            </div>
          </div>

          {/* Menu e Ícones */}
          {appData.hasMenu && (
            <div className="bg-white p-8 rounded-2xl shadow-xl">
              <h3 className="text-xl font-bold mb-6 text-gray-900 border-b border-gray-100 pb-4">Menu e Ícones</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div>
                  <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">Cor do Menu</p>
                  <div className="flex items-center mt-2">
                    <div
                      className="w-8 h-8 rounded-full border border-gray-200 mr-3 flex-shrink-0 shadow-sm"
                      style={{ backgroundColor: appData.menuColor }}
                    ></div>
                    <span className="font-semibold text-lg text-gray-900 break-all">{appData.menuColor}</span>
                  </div>
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-500 uppercase tracking-wide">Ícones Selecionados</p>
                  <p className="font-semibold text-lg text-gray-900 mt-1">{appData.icons?.length || 0} ícones</p>
                </div>
              </div>
            </div>
          )}

          {/* Resumo Financeiro */}
          <div className="bg-white p-8 rounded-2xl shadow-xl">
            <h3 className="text-xl font-bold mb-6 text-gray-900 border-b border-gray-100 pb-4">Resumo Financeiro</h3>
            <div className="space-y-4">
              <div className="flex justify-between items-center">
                <span className="text-gray-600 font-medium">Aplicação básica:</span>
                <span className="font-bold text-gray-900">R$ {priceBreakdown.base?.toFixed(2) || '0,00'}</span>
              </div>

              <div className="flex justify-between items-center">
                <span className="text-gray-600 font-medium">Logo e Splash:</span>
                <span className="font-bold text-gray-900">R$ {priceBreakdown.logo?.toFixed(2) || '0,00'}</span>
              </div>

              <div className="flex justify-between items-center">
                <span className="text-gray-600 font-medium">Personalização do loader:</span>
                <span className="font-bold text-gray-900">R$ {priceBreakdown.loader?.toFixed(2) || '0,00'}</span>
              </div>

              <div className="flex justify-between items-center">
                <span className="text-gray-600 font-medium">Plataformas:</span>
                <span className="font-bold text-gray-900">R$ {priceBreakdown.platforms?.toFixed(2) || '0,00'}</span>
              </div>

              {appData.hasMenu && (
                <>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600 font-medium">Menu de navegação:</span>
                    <span className="font-bold text-gray-900">R$ {priceBreakdown.menu?.toFixed(2) || '0,00'}</span>
                  </div>

                  {priceBreakdown.icons > 0 && (
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600 font-medium">{appData.icons?.length} ícones:</span>
                      <span className="font-bold text-gray-900">R$ {priceBreakdown.icons?.toFixed(2) || '0,00'}</span>
                    </div>
                  )}
                </>
              )}

              <div className="border-t border-gray-100 pt-4 mt-4">
                <div className="flex justify-between items-center">
                  <span className="text-xl font-bold text-gray-900">Total:</span>
                  <span className="text-2xl font-bold text-gray-900">R$ {totalPrice.toFixed(2)}</span>
                </div>
              </div>
            </div>

            {/* Informações de pagamento */}
            <div className="mt-8 p-6 bg-gray-50 rounded-xl border border-gray-100">
              <h4 className="font-bold text-gray-900 mb-4 text-center text-lg">Formas de Pagamento</h4>
              <CardIcons />
              <p className="text-sm text-gray-500 mt-4 text-center">
                Você será redirecionado para o Mercado Pago para finalizar o pagamento de forma segura.
              </p>
              <div className="mt-4 flex items-center justify-center space-x-2">
                <div className="h-2 w-2 rounded-full bg-orange-500"></div>
                <p className="text-sm font-medium text-gray-900">
                  Status inicial: <span className="text-orange-600">Pendente de Pagamento</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Botões de navegação */}
        <div className="mt-6 lg:mt-8 flex flex-col sm:flex-row gap-3 justify-between">
          <button
            onClick={handleBack}
            disabled={saving}
            className="
              w-full
              sm:w-auto
              px-4 
              py-3 
              bg-gray-300 
              text-gray-700 
              rounded-lg 
              hover:bg-gray-400 
              disabled:opacity-50 
              disabled:cursor-not-allowed
              flex 
              items-center 
              justify-center
              transition-colors
              duration-200
              min-h-[44px]
              text-base
              font-medium
              shadow-sm
            "
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" />
            </svg>
            Voltar
          </button>
          <button
            onClick={handlePayment}
            disabled={saving}
            className="
              w-full
              sm:w-auto
              px-4 
              py-3 
              bg-blue-600 
              text-white 
              rounded-lg 
              hover:bg-blue-700 
              disabled:opacity-50 
              disabled:cursor-not-allowed
              flex 
              items-center 
              justify-center
              transition-all
              duration-200
              ease-in-out
              shadow-md
              hover:shadow-lg
              focus:outline-none
              focus:ring-2
              focus:ring-blue-500
              focus:ring-opacity-50
              min-h-[44px]
              text-base
              font-medium
            "
          >
            {saving ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2"></div>
                <span className="whitespace-nowrap">Processando...</span>
              </>
            ) : (
              <>
                <span className="whitespace-nowrap">Finalizar e Pagar</span>
                <svg 
                  xmlns="http://www.w3.org/2000/svg" 
                  className="h-5 w-5 ml-2 flex-shrink-0" 
                  viewBox="0 0 20 20" 
                  fill="currentColor"
                >
                  <path 
                    fillRule="evenodd" 
                    d="M5 2a2 2 0 00-2 2v14l3.5-2 3.5 2 3.5-2 3.5 2V4a2 2 0 00-2-2H5zm4.707 5.707a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L8.414 10l1.293-1.293zm4 0a1 1 0 010 1.414L11.586 10l1.293 1.293a1 1 0 01-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0z" 
                    clipRule="evenodd" 
                  />
                </svg>
              </>
            )}
          </button>
        </div>
      </div>

      {/* Preview do aplicativo - Lado direito */}
      <div className="xl:w-[400px] lg:w-full flex-shrink-0">
        <div className="sticky top-6 lg:top-8">
          <h3 className="text-lg lg:text-xl font-semibold mb-4 text-gray-800 text-center lg:text-left">
            Preview do App
          </h3>

          <div className="flex justify-center lg:justify-start">
            <div className="relative" style={{ 
              width: 'min(100%, 400px)', 
              height: 'min(700px, 90vh)',
              maxWidth: '400px'
            }}>
              {/* Moldura do celular */}
              <div className="absolute inset-0 bg-gray-800 rounded-3xl p-3 shadow-2xl">
                <div className="h-full bg-white rounded-2xl overflow-hidden flex flex-col">

                  {/* Status Bar (como em um celular real) */}
                  <div className="bg-gray-900 text-white px-4 py-1 flex justify-between items-center text-xs">
                    <span>9:41</span>
                    <div className="flex items-center space-x-2">
                      <span>📶</span>
                      <span>📡</span>
                      <span>🔋</span>
                    </div>
                  </div>

                  {/* WebView - Site carregado dentro do app usando iframe */}
                  <div className="flex-1 relative overflow-hidden">
                    {isLoading && (
                      // Tela de carregamento
                      <div className="absolute inset-0 flex flex-col items-center justify-center bg-white z-10 p-4">
                        {appData.logo ? (
                          <img
                            src={objectUrls.logo || appData.logo}
                            alt="App Logo"
                            className="h-16 w-16 object-contain mb-4"
                          />
                        ) : (
                          <div className="h-16 w-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                            <span className="text-blue-600 font-bold text-lg">A</span>
                          </div>
                        )}

                        <div
                          className="w-8 h-8 rounded-full animate-spin"
                          style={{
                            border: `4px solid ${appData.loaderColor || '#3B82F6'}`,
                            borderTop: '4px solid transparent'
                          }}
                        ></div>

                        <p className="text-gray-500 text-sm text-center">Carregando {siteUrl}</p>
                        <p className="text-gray-400 text-xs mt-2 text-center">
                          Protocolo: {useHttps ? 'HTTPS' : 'HTTP'}
                        </p>
                      </div>
                    )}

                    {iframeError && (
                      <div className="absolute inset-0 flex flex-col items-center justify-center bg-white z-10 p-4">
                        <div className="text-red-500 text-4xl mb-4">⚠️</div>
                        <p className="text-gray-700 text-center mb-2">Não foi possível carregar o site</p>
                        <p className="text-gray-500 text-sm text-center mb-4">
                          {errorDetails || 'O site pode ter restrições de segurança que impedem a visualização em iframe.'}
                        </p>
                        
                        <div className="flex flex-col gap-2 w-full max-w-xs">
                          <button
                            onClick={reloadIframe}
                            className="bg-blue-600 text-white py-2 px-4 rounded text-sm hover:bg-blue-700 transition-colors"
                          >
                            Tentar Novamente
                          </button>
                          
                          <button
                            onClick={toggleProtocol}
                            className="bg-gray-600 text-white py-2 px-4 rounded text-sm hover:bg-gray-700 transition-colors"
                          >
                            Usar {useHttps ? 'HTTP' : 'HTTPS'}
                          </button>
                          
                          <a
                            href={siteUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 text-sm underline text-center py-2"
                          >
                            Abrir site em nova janela
                          </a>
                        </div>
                      </div>
                    )}

                    {/* Iframe carregando o site real - CONFIGURAÇÃO MELHORADA */}
                    <iframe
                      key={iframeKey}
                      ref={iframeRef}
                      src={siteUrl}
                      title="Preview do site"
                      className="w-full h-full border-0"
                      onLoad={() => {
                        setIsLoading(false);
                        setIframeError(false);
                        setErrorDetails('');
                        setRetryCount(0);
                      }}
                      onError={handleIframeError}
                      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-modals"
                      allow="accelerometer; camera; encrypted-media; geolocation; gyroscope; microphone; midi; payment"
                      referrerPolicy="no-referrer-when-downgrade"
                      style={{
                        overflow: 'hidden'
                      }}
                    />
                  </div>

                  {/* Menu Button (na parte inferior) */}
                  {appData.hasMenu && (
                    <div
                      className="border-t border-gray-200"
                      style={{ backgroundColor: appData.menuColor || '#3B82F6' }}
                    >
                      <div className="flex justify-around items-center p-2">
                        {appData.icons && appData.icons.slice(0, 5).map((iconObj, index) => {
                          const iconDef = predefinedIcons.find(pi => pi.id === iconObj.id);
                          const IconComponent = iconDef ? iconDef.icon : null;
                          return (
                            <div key={index} className="flex flex-col items-center p-1">
                              {IconComponent ? (
                                <IconComponent className="h-5 w-5 lg:h-6 lg:w-6 text-white" />
                              ) : iconObj.url ? (
                                <img 
                                  src={iconObj.url} 
                                  alt={iconObj.name} 
                                  className="h-5 w-5 lg:h-6 lg:w-6 object-contain filter brightness-0 invert" 
                                />
                              ) : null}
                              <span className="text-[10px] text-white mt-1 truncate max-w-[50px]">{iconObj.name}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="mt-4 text-center lg:text-left">
            <p className="text-sm text-gray-500 break-all">Carregando: {siteUrl}</p>
            <p className="text-xs text-gray-400 mt-1">
              {appData.url ? 'Site real carregado no app' : 'URL não definida - usando exemplo.com'}
              {useHttps ? ' (HTTPS)' : ' (HTTP)'}
            </p>
            {iframeError && (
              <p className="text-xs text-red-500 mt-1 text-center lg:text-left">
                {errorDetails || 'Erro ao carregar. Alguns sites não permitem visualização em iframe.'}
              </p>
            )}
            {retryCount > 0 && (
              <p className="text-xs text-orange-500 mt-1 text-center lg:text-left">
                Tentativas: {retryCount}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Step6;